import * as React from 'react'
import styled from 'styled-typed'
import { Radio, RadioWrapper } from 'uiComponents/input/radio'
import { DateRangeType } from 'uiComponents/popups/comparisonDateRangePicker/schema'
import { Body } from 'uiComponents/typography'
import { useTranslation } from 'translations'

const Container = styled.div`
    display: flex;
    justify-content: center;
`
const OptionWrapper = styled(RadioWrapper)`
    cursor: pointer;
    margin: 0.1em 0;
    &:first-child {
        margin-right: 0.7em;
    }
`
const RadioText = styled(Body)`
    &.disabled {
        opacity: 0.5;
        cursor: default;
    }
`

interface DateRangeTypeSelectProps {
    dateRangeType: DateRangeType
    onChange: (type: DateRangeType) => void
    disabled?: boolean
}

export function DateRangeTypeSelect(props: DateRangeTypeSelectProps) {
    const { t } = useTranslation()
    const [dateRangeType, setDateRangeType] = React.useState<DateRangeType>('sale')

    React.useEffect(() => {
        setDateRangeType(props.dateRangeType)
    }, [props.dateRangeType])

    const onChange = (type: DateRangeType) => {
        setDateRangeType(type)
        props.onChange(type)
    }

    return (
        <Container>
            <OptionWrapper>
                <Radio
                    onChange={() => onChange('sale')}
                    checked={dateRangeType === 'sale'}
                    checkMarkSize="small"
                    disabled={props.disabled}
                />
                <RadioText
                    size={2}
                    weight={dateRangeType === 'sale' ? 'medium' : 'regular'}
                    className={props.disabled ? 'disabled' : ''}
                >
                    {t('uiComponents.popups.dateRangePicker.dateOfSale')}
                </RadioText>
            </OptionWrapper>
            <OptionWrapper>
                <Radio
                    onChange={() => onChange('visit')}
                    checked={dateRangeType === 'visit'}
                    checkMarkSize="small"
                    disabled={props.disabled}
                />
                <RadioText
                    size={2}
                    weight={dateRangeType === 'visit' ? 'medium' : 'regular'}
                    className={props.disabled ? 'disabled' : ''}
                >
                    {t('uiComponents.popups.dateRangePicker.dateOfVisit')}
                </RadioText>
            </OptionWrapper>
        </Container>
    )
}

interface DateRangeTogglerProps {
    dateRangeOn?: boolean
    enableDateRange: (v: boolean) => void
}

export function DateRangeToggler(props: DateRangeTogglerProps) {
    const { t } = useTranslation()
    return (
        <Container>
            <OptionWrapper>
                <Radio
                    onChange={() => props.enableDateRange(false)}
                    checked={!props.dateRangeOn}
                    checkMarkSize="small"
                />
                <RadioText size={2} weight={props.dateRangeOn ? 'regular' : 'medium'}>
                    {t('uiComponents.popups.dateRangePicker.showAll')}
                </RadioText>
            </OptionWrapper>
            <OptionWrapper>
                <Radio onChange={() => props.enableDateRange(true)} checked={props.dateRangeOn} checkMarkSize="small" />
                <RadioText size={2} weight={props.dateRangeOn ? 'medium' : 'regular'}>
                    {t('uiComponents.popups.dateRangePicker.defineByDateRange')}
                </RadioText>
            </OptionWrapper>
        </Container>
    )
}
